import { ScoreCardEvaluatorsService } from 'api-clients/monolith/services/ScoreCardEvaluatorsService';
import { useCallback } from 'react';

import { useApiService } from 'hooks/useApiService';

export const useEvaluators = (templateId: number, applicantId: string) => {
  const fetchEvaluators = useCallback(
    () =>
      ScoreCardEvaluatorsService.getInternalApiScoreCardsTemplatesApplicantsEvaluators(
        templateId,
        applicantId,
      ),
    [templateId, applicantId],
  );

  return useApiService(fetchEvaluators, {
    enabled: Number.isFinite(templateId) && Boolean(applicantId),
  });
};
